import React from "react";
import Wrp from '../../../../../../../hoc/Wrp/Wrp';


const ShowNotification = (props)=>{
    const {reminderJson,actionChangeHandler, isPopupNeeded} = props;
    return(
      <Wrp>
        <div className="form-group row">
                  <label className="d-blockdd text-wrap col-lg-2 col-md-4 "> Show Notification  </label> 
                  <div className="selectgroup display-block  col-lg-5 col-md-8 ">
                  <span className="px-2"> : </span>
                      <label className="selectgroup-item">
              <input 
                type="radio" 
                name="icon-input" 
                className="selectgroup-input"
                onChange={e=>actionChangeHandler(e,'remind_alert',0)}
                checked={(reminderJson.remind_alert===0)?true:false}
               />
                          <span className="selectgroup-button selectgroup-button-icon"> 
                {`Email`}  
              </span>
                      </label>
                      {(isPopupNeeded) && (
                        <label className="selectgroup-item">
              <input 
                type="radio" 
                name="icon-input" 
                className="selectgroup-input"
                onChange={e=>actionChangeHandler(e,'remind_alert',1)}
                checked={(reminderJson.remind_alert===1)?true:false} />
                          <span className="selectgroup-button selectgroup-button-icon"> 
                {`Popup`} 
              </span>
                      </label>
                      )}
                     
                      <label className="selectgroup-item">
              <input 
                type="radio" 
                name="icon-input" 
                className="selectgroup-input"
                onChange={e=>actionChangeHandler(e,'remind_alert',2)}
                checked={(reminderJson.remind_alert===2)?true:false} />
                        <span className="selectgroup-button selectgroup-button-icon"> 
                {`${isPopupNeeded ? 'Both' : "Email and Popup"}`}
              </span>
                      </label>
                  </div>
              </div>
      </Wrp>
    )
  }

  ShowNotification.defaultProps={
    isPopupNeeded: true
  }

  export default ShowNotification;